
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/tag/[slug]",
      function () {
        return require("private-next-pages/help/tag/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/tag/[slug]"])
      });
    }
  